export const formatRows = (listaItems) =>
  listaItems.map((item) => ({
    id: item.id ?? "Id no disponible",
    desc_descripcion: item.desc_descripcion ?? "Descuento no disponible",
    desc_porcentaje: item.desc_porcentaje ?? 0,
    monto_minimo: item.monto_minimo ?? 0,
    monto_maximo: item.monto_maximo ?? 0,
    desc_fecha_inicio: item.desc_fecha_inicio
      ? item.desc_fecha_inicio
      : "Fecha no disponible",
    desc_fecha_fin: item.desc_fecha_fin
      ? item.desc_fecha_fin 
      : "Fecha no disponible",
    desc_activo: item.desc_activo,
  }));
